/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 13:56:48
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-10-13 16:48:21
 * @FilePath: \hlweb2.0\src\pages\SuccessStories\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import "antd/dist/antd.css";
import Top from "../../components/common/Top";
import Footer from "../../components/common/Footer";
import FreeTrial from "../../components/FreeTrial";
import Banner from "./Banner";
import BeforeBanner from "./BeforeBanner";
import { Layout } from "antd";
import actionWays from "../../redux/actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../../inphone.scss";
import ProductServices from "./casesList";
import { addBrowseNumber } from "../../utils/api";
import { adaptation } from "../../utils/adaptation";
const { Content } = Layout;
class SuccessStories extends React.Component {
  constructor(props) {
    super(props);
    const state = this.props.location.state || {};
    this.state = {
      showScroll: false,
      isDisabled: state.isDisabled || false,
    };
  }
  componentDidMount = () => {
    console.log("this.props.location", this.props.location);

    document.body.scrollTop = document.documentElement.scrollTop = 0;
    const intervalScroll = setInterval(() => {
      if (
        document.documentElement.clientHeight +
          document.documentElement.scrollHeight >
        3000
      ) {
        console.log(document.documentElement.clientHeight);
        console.log(document.documentElement.scrollTop);
        this.setState({
          showScroll: true,
        });
        clearInterval(intervalScroll);
      }
    }, 100);
    // 浏览次数
    if (window.location.hash == "#/") {
      this.addNumber();
    }
    adaptation();
  };
  componentDidUpdate(prevProps) {
    // 当从其他页面跳转回来且 state 改变时触发
    if (this.props.location.state !== prevProps.location.state) {
      const { isDisabled } = this.props.location.state || {};
      console.log("检测到路由 state 变化:", isDisabled);

      // 更新组件内部状态
      this.setState({
        isDisabled: isDisabled ?? false,
      });
    }
  }
  addNumber = async () => {
    let data = await addBrowseNumber();
    console.log(data);
  };
  changeIsDisabled = (isDisabled) => {
    this.setState({
      isDisabled,
    });
  };
  render() {
    const { isDisabled } = this.state;
    return (
      <Layout
        style={{ minHeight: "100%", minWidth: "100%" }}
        id="SuccessStoriesId"
      >
        <Top />
        {/* <ContactModel /> */}
        <Content id="contentId">
          {isDisabled ? (
            <>
              {/* banner图 start*/}
              <Banner />
              {/* banner图 end*/}
              {/* 产品中心 */}
              <ProductServices />
              {/* 产品中心 */}
              {/* 在线体验  start*/}
              <FreeTrial />
              {/* 在线体验  end*/}{" "}
            </>
          ) : (
            <>
              <BeforeBanner changeIsDisabled={this.changeIsDisabled}/>
            </>
          )}
          <Footer />
        </Content>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SuccessStories));
